import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import i18n from "i18next";
import "slick-carousel/slick/slick-theme.css";
import { CauseInput } from "../../../components/CauseInput";

interface CauseSelectorProps {
  causesToOffer: any;
  selectedCauses: any;
  existingRecord: any;
  selectedCause: any;
  handleCauseSelect: any;
  onDelete?: () => void;
  onFinish?: (causeTypeId?: string) => void;
  onClose?: () => void;
  userId?: unknown;
  navigate?: unknown;
  selectedDate?: unknown;
  yourOwnCause: string;
  setYourOwnCause: (yourOwnCause: string) => void;
  setYourOwnCauseTypeId: (causeTypeId: string) => void;
}

const CauseSelector: React.FC<CauseSelectorProps> = ({
  causesToOffer,
  selectedCauses,
  existingRecord,
  selectedCause,
  handleCauseSelect,
  yourOwnCause,
  setYourOwnCause,
  setYourOwnCauseTypeId,
  onDelete,
  onFinish,
}) => {
  const { t } = useTranslation();
  const [isAddYourOwnCause, setIsAddYourOwnCause] = useState(false);

  return (
    <>
      <div className="select-component__duration-section">
        {causesToOffer.map((option: any) => {
          const isSelected = selectedCauses?.some(
            (c: any) => c.id === option.id
          );

          return (
            <div>
              <button
                key={option.id}
                className="strength-button select-component__duration-button"
                style={{ fontWeight: isSelected ? "bold" : "normal" }}
                onClick={
                () => {
                  handleCauseSelect(option, "lorem")
                  if (onFinish) {
                    onFinish(option.id);
                  }
                }
              }
              >
                {option.causeTypeTranslation?.[i18n.language] ||
                  option.translation ||
                  option.mood ||
                  "No translation"}
              </button>
            </div>
          );
        })}
        <CauseInput
          isAddYourOwnCause={isAddYourOwnCause}
          setIsAddYourOwnCause={setIsAddYourOwnCause}
          yourOwnCause={yourOwnCause}
          setYourOwnCause={setYourOwnCause}
          setYourOwnCauseTypeId={setYourOwnCauseTypeId}
        />
      </div>

      {selectedCauses.length === 0 && (
        <button
          onClick={() => {
            console.log("clicked");
            if (onFinish) {
              onFinish();
            }
          }}
          className="proceed-button"
        >
          Save without causes
        </button>
      )}

      {!selectedCause && (
        <div>
          {selectedCauses.length > 0 && (
            <button
              onClick={() => {
                if (onFinish) {
                  console.log("trigger onFinish")
                    onFinish();
                }
              }}
              className="proceed-button"
            >
              Proceed
            </button>
          )}

          {existingRecord != null && (
            <button
              className="track-button-causes"
              onClick={() => {
                if (onDelete) {
                  onDelete();
                }
              }}
            >
              {t("homepage.delete")}
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default CauseSelector;
